import { ApiResponse } from "apisauce";
import { IResponseSnapshot } from '../../models';
import { IPredictionRecord } from '../../models/prediction-record/PredictionRecord';
import { Api } from "../api/api";
import { getGeneralApiProblem } from "../api/api-problem";
import {
  TDeletePredictionRecordResult, TGetPredictionRecordResult, TGetPredictionRecordsResult, TPostPredictionRecordResult,
  TUpdatePredictionRecordResult
} from "./PredictionRecordTypes";

  /**
  * # PredictionRecord Api 서비스
  * 
  * 서비스의 설명을 작성하세요.
  * 
  * ## 사용방법
  * 
  * ```ts
  * const service = new PredictionRecordApi();
  * 
  * ```
  */
 export class PredictionRecordApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  private BASE_URL = '/predictionRecord'

  async getPredictionRecordHistory(data:any): Promise<TGetPredictionRecordsResult> {
    try {
      const url = `${this.BASE_URL}/history/${data.patientId}`;
      const params = {
        "startDate": data.startDate,
        "endDate": data.endDate
      };
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const predictionRecords: IPredictionRecord[] = response.data.data;
      const responseInfo: IResponseSnapshot = response.data;
      return { kind: "ok", predictionRecords, responseInfo:responseInfo };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  async getPredictionRecord(id:number): Promise<TGetPredictionRecordResult> {
    try {
      const url = `/prediction_record/${id}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get( url, params );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const predictionRecord: IPredictionRecord = response.data.results;
      return { kind: "ok", predictionRecord };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  async postPredictionRecord(): Promise<TPostPredictionRecordResult> {
    try {
      const url = '/prediction_record';
      const payload = {};
      const response: ApiResponse<any> = await this.api.apisauce.post( url, payload );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const predictionRecord: IPredictionRecord = response.data.results;
      return { kind: "ok", predictionRecord };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  async updatePredictionRecord(id:number): Promise<TUpdatePredictionRecordResult> {
    try {
      const url = `/prediction_record/${id}`;
      const payload = {};
      const response: ApiResponse<any> = await this.api.apisauce.put( url, payload );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const predictionRecord: IPredictionRecord = response.data.results;
      return { kind: "ok", predictionRecord };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }

  async deletePredictionRecord(id:number): Promise<TDeletePredictionRecordResult> {
    try {
      const url = `/prediction_record/${id}`;
      const payload = {};
      const response: ApiResponse<any> = await this.api.apisauce.delete( url, payload );
  
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      return { kind: "ok" };

    } catch (e) {
      return { kind: "bad-data" };
    }
  }
}